import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import StaffPage from "@/components/StaffPage";
import PublicSite from "@/components/site/PublicSite";
import { SeoLanding } from "@/components/site/SeoLanding";
import { EventPage } from "@/components/site/EventPage";
import { bagaGuideConfig, bollywoodConfig, ladiesNightConfig, tableBookingConfig } from "@/components/site/seoConfigs";
import { API, fallbackEvents } from "@/lib/site";

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

const LANDING_PAGES = {
  "/bollywood-nights-goa": bollywoodConfig,
  "/clubs-in-baga": bagaGuideConfig,
  "/ladies-night-goa": ladiesNightConfig,
  "/vip-table-booking-goa": tableBookingConfig,
};

export default function App() {
  const [eventList, setEventList] = useState(fallbackEvents);
  const [eventsLoaded, setEventsLoaded] = useState(false);
  const isStaff = window.location.pathname === "/staff";

  useEffect(() => {
    if (META_PIXEL_ID && !window.fbq) {
      window.fbq = function () { window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments); };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = "2.0";
      window.fbq.queue = [];
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(script);
      window.fbq("init", META_PIXEL_ID);
      window.fbq("track", "PageView");
    }
  }, []);

  useEffect(() => {
    if (isStaff) return undefined;
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, [isStaff]);

  useEffect(() => {
    axios.get(`${API}/events`)
      .then((response) => setEventList(response.data))
      .catch(() => {})
      .finally(() => setEventsLoaded(true));
  }, []);

  const path = window.location.pathname;
  if (path === "/staff") return <StaffPage />;
  if (LANDING_PAGES[path]) return <SeoLanding config={LANDING_PAGES[path]} events={eventList} eventsLoaded={eventsLoaded} />;
  if (path.startsWith("/events/")) return <EventPage slug={path.split("/events/")[1]} events={eventList} eventsLoaded={eventsLoaded} />;
  return <PublicSite events={eventList} eventsLoaded={eventsLoaded} />;
}
